import * as React from "react";
import {Alert, Spinner, Button, Accordion, Card, Modal, Form, Row, Col} from "react-bootstrap";
import withRequestState from "../../components/WithRequestState";
import {connect} from "react-redux";
import { RequestStateProps } from "../../interfaces/RequestState";
import {getUsers, GET_USERS_REQUEST, createUser, deleteUser} from "../../redux/users/actions";
import User from "../../interfaces/User";
import { State } from "../../interfaces/State";
import SideBar from "../../components/SideBar/Sidebar";
import { withRouter, RouteComponentProps} from "react-router-dom";
import {Formik} from "formik";
import * as Yup from "yup";
import "./index.scss";

interface IState {
    inviteUser: boolean;
}

interface IProps {
    getUsers: () => void;
    users: User[];
    createUser: (username, password, email) => void;
    deleteUser: (user) => void;
}

class UsersPage extends React.Component<IProps & RequestStateProps & RouteComponentProps, IState> {

    constructor(props){
        super(props);
        this.state = {
            inviteUser: false
        }
    }

    componentDidMount(){
        this.props.getUsers();
    }

    goBack(){
        this.props.history.goBack();
    }

    deleteUser(user){
        this.props.deleteUser(user);
    }

    goTo(id:number){
        this.props.history.push(`/people/${id}`);
    }

    render(){
        return (
            <div id="people-page">
                <div className="top-banner p-4">
                    <h3>People</h3>
                </div>

                <div className="p-4">   
                    
                    
                    <h4>Workers list</h4>
                    <p>Bla bla bla</p>

                    <Row>
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label>Search people</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="search"
                                />    
                            </Form.Group>                        
                        </Col>
                        <Col />
                        <Col md={3}>
                            <div className="d-flex align-items-center">
                                <Button className="toggle-button mx-1">On site</Button>
                                <Button className="toggle-button mx-1">Off site</Button>
                                <Button className="toggle-button mx-1">Filter</Button>
                                <Button className="toggle-button mx-1">Bulk action</Button>
                            </div>                  
                        </Col>
                    </Row>


                    <div className="mt-4">
                        {
                            this.props.isPending ? 
                            <Spinner animation="border" /> :
                                <div className="list">
                                    <Row className="list-header mt-3 p-3" noGutters>
                                        <Col md={1} xs={1}>#</Col>
                                        <Col>Name</Col>
                                        <Col>Phone</Col>
                                        <Col>Email</Col>
                                        <Col>Project</Col>
                                        <Col>Contactor</Col>
                                        <Col>Status</Col>
                                        <Col>Last updated</Col>
                                        <Col md={1}>Details</Col>
                                    </Row>
                                    <div>
                                    {
                                        this.props.users.map((user, index) => (
                                            <Row className="list-item" key={index} onClick={() => this.goTo(user.id)} noGutters>
                                                <Col md={1} xs={1}>
                                                    {index+1}
                                                </Col>
                                                <Col>
                                                    <i className="fas fa-user-circle" />
                                                    {user.name}
                                                </Col>
                                                <Col>
                                                    {user.phoneNumber}
                                                </Col>
                                                <Col className="disable-click">
                                                    <a href={`mailto:${user.email}`}>{user.email}</a>
                                                </Col>
                                                <Col>None</Col>
                                                <Col>None</Col>
                                                <Col>Unknown</Col>
                                                <Col>Last updated</Col>
                                                <Col md={1} xs={1} className="text-right">
                                                    <i className="material-icons">
                                                        chevron_right
                                                    </i>
                                                </Col>
                                            </Row>
                                        ))
                                    }
                                    </div>
                                </div>
                        }
                        

                        <Button onClick={() => this.setState({inviteUser: true})} className="mt-3">
                            Add new user
                        </Button>
                    </div>


                    <Modal
                        show={this.state.inviteUser}
                        centered
                    >
                            <Modal.Header>
                            <Modal.Title>New User</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Formik
                                initialValues={{
                                    username: "",
                                    password: "",
                                    email: ""
                                }}
                                validationSchema={Yup.object().shape({
                                    email: Yup.string().email("Email must be a valid email")
                                })}
                                onSubmit={({username, password, email}) => {
                                    this.props.createUser(username, password, email);
                                }}
                            >
                                {(props) => (
                                    <Form onSubmit={props.handleSubmit}>
                                        <Form.Group>
                                            <Form.Label>
                                                Username
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={props.values.username}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                name="username"
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>
                                                Email
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={props.values.email}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                name="email"
                                                isInvalid={!!props.errors.email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {props.errors.email}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Row>
                                            <Col xs={12} md={6}>
                                                {
                                                    this.props.isPending ? 
                                                        <div className="d-flex align-items-center">
                                                            <Spinner animation="border" />
                                                            Loading...
                                                        </div> :
                                                        <Button type="submit" variant="primary" className="w-100">
                                                            Submit
                                                        </Button>
                                                }
                                            </Col>
                                            <Col xs={12} md={6} className="text-right order-12">
                                                <Button variant="outline-primary" className="w-100" onClick={() => this.setState({inviteUser: false})}>Close</Button>
                                            </Col>
                                        </Row>   
                                    </Form>
                                )}
                            </Formik>
                        </Modal.Body>
                        
                    </Modal>

                </div>
            </div>
        )
    }

}


export default withRouter(connect((state : State) => ({
    users: state.users
}), ({
    getUsers,
    createUser,
    deleteUser
}))(withRequestState(UsersPage, [GET_USERS_REQUEST])));